import { LazyImport, LazyModule } from 'owa-bundling';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "DiagnosticReport", webpackPrefetch: true */ './lazyIndex')
);

export const lazyAppendDiagnosticReportToMessage = new LazyImport(
    lazyModule,
    m => m.appendDiagnosticReportToMessage
);
export const lazyGenerateDiagnosticReport = new LazyImport(
    lazyModule,
    m => m.generateDiagnosticReport
);
